import React, { useState } from "react";
import { FaHome, FaSignOutAlt, FaThLarge } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import "./Sidebar.css";
import MenuModal from "./MenuModal";
import { AuthContext } from "../../context/Authcontext";
import { logout as logoutRequest, resetSessionFlag } from "../../utils/api";
import { sectionViewPermission } from "../../utils/permissions";
import useBrandLogo from "../../utils/useBrandLogo";
import { NavIcon, pathFor, visibleGroups } from "./navigation";

const DASHBOARD_ITEM = { key: "dashboard", label: "Dashboard", icon: FaHome, color: "#ff6e00" };

export default function Sidebar() {
  const [isModalOpen, setModalOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const { user, logout, can } = React.useContext(AuthContext);
  const logoSrc = useBrandLogo("/logo.png");

  if (!user) {
    return null;
  }

  const groups = visibleGroups((key) => can(sectionViewPermission(key)));
  const isActive = (path) => location.pathname === path || location.pathname.startsWith(`${path}/`);
  const displayName = [user?.firstName, user?.lastName].filter(Boolean).join(" ") || user?.email || "Admin";
  const roleLabel = user?.role === "admin" ? "Admin" : (user?.roleName || "Medewerker");

  const handleLogout = async () => {
    try {
      await logoutRequest();
    } catch (error) {
      console.error("Logout request failed:", error);
    } finally {
      resetSessionFlag();
      logout();
      navigate("/");
    }
  };

  const renderItem = (item, path) => (
    <li
      key={item.key}
      title={item.label}
      className={isActive(path) ? "active" : ""}
      onClick={() => navigate(path)}
    >
      <NavIcon item={item} />
      <span className="label">{item.label}</span>
    </li>
  );

  return (
    <>
      <aside className="sidebar">
        <button className="brand-button" type="button" onClick={() => navigate("/dashboard")}>
          <img src={logoSrc} alt="Logo" className="logo" title="Dashboard" />
          <div className="brand-copy">
            <strong>MyDharma Admin</strong>
            <span>{displayName}</span>
            <span className="brand-role">{roleLabel}</span>
          </div>
        </button>

        <nav className="sidebar-scroll">
          <ul className="sidebar-nav">{renderItem(DASHBOARD_ITEM, "/dashboard")}</ul>
          {groups.map((group) => (
            <div className="sidebar-group" key={group.key}>
              <div className="sidebar-group-label">{group.label}</div>
              <ul className="sidebar-nav">
                {group.items.map((item) => renderItem(item, pathFor(item.key)))}
              </ul>
            </div>
          ))}
        </nav>

        <div className="sidebar-footer">
          <button className="expand-btn" type="button" onClick={() => setModalOpen(true)} title="Volledig menu">
            <FaThLarge />
            <span>Volledig menu</span>
          </button>
          <button className="logout-btn" type="button" onClick={handleLogout} title="Uitloggen">
            <FaSignOutAlt />
            <span>Uitloggen</span>
          </button>
        </div>
      </aside>

      {isModalOpen && (
        <MenuModal
          groups={groups}
          currentPath={location.pathname}
          onLogout={handleLogout}
          onClose={() => setModalOpen(false)}
        />
      )}
    </>
  );
}
